import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import SuccessPopup from "components/common/SuccessPopup";
import {
  SHARED_SITES_WITH,
  UPDATED_SITE,
  ADDED_PLANTED_ACRES,
  UPDATED_PLANTED_ACRES,
  UPDATED_RECIPE_USAGE,
  ADDED_RECIPE_USAGE,
} from "configurations/MessageConstants";
import {
  setShareSiteSuccess,
  setSaveSiteSuccess,
} from "reduxStore/slices/siteSlice";
import { setSavePlantedAcreSuccess } from "reduxStore/slices/plantedAcresSlice";
import { setSaveRecipeUsageSuccess } from "reduxStore/slices/recipeUsageSlice";
import { useDispatch } from "react-redux";
import { MODE_TYPES } from "configurations/Constants";

const MySitesScreens = () => {
  const dispatch = useDispatch();
  const shareSiteSuccess = useSelector((state) => state.site.shareSiteSuccess);
  const saveSiteSuccess = useSelector((state) => state.site.saveSiteSuccess);
  const savedSite = useSelector((state) => state.site.savedSite);
  const sharedSiteInfo = useSelector((state) => state.site.sharedSiteInfo);
  const savePlantedAcreSuccess = useSelector(
    (state) => state.plantedAcres.savePlantedAcreSuccess
  );
  const plantedAcreMode = useSelector(
    (state) => state.plantedAcres.plantedAcreMode
  );
  const savedPlantedAcre = useSelector(
    (state) => state.plantedAcres.savedPlantedAcre
  );
  const saveRecipeUsageSuccess = useSelector(
    (state) => state.recipeUsage.saveRecipeUsageSuccess
  );
  const savedRecipeUsage = useSelector(
    (state) => state.recipeUsage.savedRecipeUsage
  );
  const recipeUsageMode = useSelector(
    (state) => state.recipeUsage.recipeUsageMode
  );

  const renderShareSiteSuccess = () => {
    const { success, details, farmerName } = sharedSiteInfo;
    if (!success.length && !details.length) return null;
    return (
      <>
        {success.length > 0 && (
          <div className="mb-2">
            <span>
              {SHARED_SITES_WITH} {farmerName}:{" "}
            </span>
            <span className="fw-bold">
              {success.map((site) => site.siteName || site).join(", ")}
            </span>
          </div>
        )}
        {details.length > 0 && (
          <div>
            {details.map((detail, index) => (
              <div className="mb-2" key={detail.reason + index}>
                {detail.reason}:{" "}
                <span className="fw-bold">{detail.siteNames.join(", ")}</span>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  return (
    <div className="scrollable-container">
      <Outlet />
      {shareSiteSuccess && (
        <SuccessPopup
          message={renderShareSiteSuccess()}
          show={shareSiteSuccess}
          handleClose={() => dispatch(setShareSiteSuccess(false))}
        />
      )}
      {saveSiteSuccess && (
        <SuccessPopup
          message={UPDATED_SITE}
          value={savedSite?.name}
          show={saveSiteSuccess}
          handleClose={() => dispatch(setSaveSiteSuccess(false))}
        />
      )}
      {savePlantedAcreSuccess && (
        <SuccessPopup
          message={
            plantedAcreMode === MODE_TYPES.ADD
              ? ADDED_PLANTED_ACRES
              : UPDATED_PLANTED_ACRES
          }
          value={savedPlantedAcre?.name}
          show={savePlantedAcreSuccess}
          handleClose={() => dispatch(setSavePlantedAcreSuccess(false))}
        />
      )}
      {saveRecipeUsageSuccess && (
        <SuccessPopup
          message={
            recipeUsageMode === MODE_TYPES.ADD
              ? ADDED_RECIPE_USAGE
              : UPDATED_RECIPE_USAGE
          }
          value={savedRecipeUsage?.recipeName}
          show={saveRecipeUsageSuccess}
          handleClose={() => dispatch(setSaveRecipeUsageSuccess(false))}
        />
      )}
    </div>
  );
};

export default MySitesScreens;
